import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BuyerInformationComponent } from '../components/buyer-information/buyer-information.component';
import { AUTOCOMPLETE_FORM_CONTROLS, AUTOCOMPLETE_METHOD_PAY_TYPES } from '../core/constants/General-constants';

@Injectable({
  providedIn: 'root',
})
export class PatchValAdditionalInfoService {
  isProdEnv: boolean = environment.production;
  addressInfo: any;
  form: any;

  patchValAdditionalInfo(
    isEditableInfo: boolean,
    additionalInformation: any,
    form: any,
    methodPayType,
    objectControlData?: any,
    buyerInformationComponent?: BuyerInformationComponent,
    buyerInfoControl?: any,
    countryCode?: number
  ) {
    isEditableInfo = isEditableInfo ? false : true;
    const client = additionalInformation?.client || '';
    const personal_information = client.personal_information || '';
    const address = client?.address || '';
    const contact_information = personal_information?.contact_information || '';

    const result: {addressInfo?: any; buyerInfoControl?: any } = {};

    if (methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.CONSUMER_CREDIT) {
      if (personal_information.firstname) {
        let lastName = `${personal_information.lastname ?? ''}`;

        form
          .get(AUTOCOMPLETE_FORM_CONTROLS.TITULAR_NAME)
          .setValue(`${personal_information.firstname} ${lastName}`);

        this.setReadOnly(
          isEditableInfo,
          AUTOCOMPLETE_FORM_CONTROLS.TITULAR_NAME,
          objectControlData
        );
      }

      if (personal_information.document.type) {
        form
          .get(AUTOCOMPLETE_FORM_CONTROLS.DOCUMENT_TYPE)
          .setValue(personal_information.document.type);

        this.setReadOnly(
          isEditableInfo,
          AUTOCOMPLETE_FORM_CONTROLS.DOCUMENT_TYPE,
          objectControlData
        );
      }

      if (personal_information.document.id) {
        form
          .get(AUTOCOMPLETE_FORM_CONTROLS.DOCUMENT_NUMBER)
          .setValue(personal_information.document.id);

        this.setReadOnly(
          isEditableInfo,
          AUTOCOMPLETE_FORM_CONTROLS.DOCUMENT_NUMBER,
          objectControlData
        );
      }

      return;
    }

    if (
      contact_information &&
      methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.TC
    ) {
      buyerInfoControl = this.validContactIndformation(
        isEditableInfo,
        contact_information,
        buyerInformationComponent,
        objectControlData,
        buyerInfoControl
        );
    }

    this.addressInfo = address ?? '';

    if (address?.line1 && methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.PSE) {
      form.controls.address.setValue(address?.line1);

      objectControlData.find(
        (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.BILL_ADDRESS_LINE_1
      ).readOnly = isEditableInfo;
    }

    if (address?.line1 && methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.PSE_WALLETS ) {
      form.controls.address.setValue(address?.line1);

      objectControlData.find(
        (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.ADDRESS
      ).readOnly = isEditableInfo;
    }

    if ( methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.WALLETS || methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.DEPOSITS_AND_TRANSFERS ) {
      if (countryCode) {
        form.controls.country.setValue(countryCode);

        objectControlData.find(
          (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.COUNTRY
        ).readOnly = isEditableInfo;
      }
      if (contact_information && contact_information.email) {
        form.controls.email.setValue(contact_information.email);

        objectControlData.find(
          (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.EMAIL
        ).readOnly = isEditableInfo;
      }

      return;
    }

    if (personal_information) {
      if (personal_information.firstname && methodPayType != AUTOCOMPLETE_METHOD_PAY_TYPES.DAVIPLATA_NATIVE && methodPayType != AUTOCOMPLETE_METHOD_PAY_TYPES.DEUNA ) {

        if ( methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.PSE_WALLETS) {
          const fullName = `${personal_information.firstname} ${personal_information.lastname ?? ''}`;

          form.get(AUTOCOMPLETE_FORM_CONTROLS.NAME).setValue(fullName);
        } else {
          form.get(AUTOCOMPLETE_FORM_CONTROLS.NAME).setValue(personal_information.firstname);
        }

        objectControlData.find( (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.NAME ).readOnly = isEditableInfo;
      }

      if (personal_information.lastname && methodPayType != AUTOCOMPLETE_METHOD_PAY_TYPES.PSE_WALLETS && methodPayType != AUTOCOMPLETE_METHOD_PAY_TYPES.DAVIPLATA_NATIVE && methodPayType != AUTOCOMPLETE_METHOD_PAY_TYPES.DEUNA) {
        const lastNameControl =
          methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.TC
            ? AUTOCOMPLETE_FORM_CONTROLS.LAST_NAME_TC
            : AUTOCOMPLETE_FORM_CONTROLS.LAST_NAME_PSE;

        form.get(lastNameControl).setValue(personal_information.lastname);

        objectControlData.find(
          (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.LAST_NAME_TC
        ).readOnly = isEditableInfo;
      }

      if (personal_information.document.type && methodPayType != AUTOCOMPLETE_METHOD_PAY_TYPES.DEUNA) {

        if (methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.DAVIPLATA_NATIVE) {
          form.get(AUTOCOMPLETE_FORM_CONTROLS.DOCUMENT_TYPE_2).setValue(personal_information.document.type);

          objectControlData.find( (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.DOCUMENT_TYPE_2).readOnly = isEditableInfo;
        } else {
          form.get(AUTOCOMPLETE_FORM_CONTROLS.TYPE_DI).setValue(personal_information.document.type);

          objectControlData.find( (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.TYPE_DI).readOnly = isEditableInfo;
        }
      }

      if (personal_information.document.id && methodPayType != AUTOCOMPLETE_METHOD_PAY_TYPES.DEUNA) {
        if (methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.DAVIPLATA_NATIVE) {
          form.get(AUTOCOMPLETE_FORM_CONTROLS.DOCUMENT_NUMBER).setValue(personal_information.document.id);

          objectControlData.find( (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.DOCUMENT_NUMBER).readOnly = isEditableInfo;
        } else {
          form.get(AUTOCOMPLETE_FORM_CONTROLS.DI).setValue(personal_information.document.id);

          objectControlData.find( (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.DI).readOnly = isEditableInfo;
        }

      }

      if (methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.PSE ||
            methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.PUNTOS_COLOMBIA ||
            methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.PSE_WALLETS ||
            methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.DEUNA) {
        if (contact_information && contact_information.phone && methodPayType != AUTOCOMPLETE_METHOD_PAY_TYPES.DEUNA) {
          form.controls.cellPhone.setValue(contact_information.phone);

          objectControlData.find( (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.CELLPHONE ).readOnly = isEditableInfo;
        }

        if (contact_information && contact_information.email && methodPayType != AUTOCOMPLETE_METHOD_PAY_TYPES.DAVIPLATA_NATIVE) {
          form.controls.email.setValue(contact_information.email);

          objectControlData.find( (m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.EMAIL).readOnly = isEditableInfo;
        }
      }
    }

    if (methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.TC){
      result.addressInfo = address;
      result.buyerInfoControl = buyerInfoControl;
      return result;
    }

    if (methodPayType === AUTOCOMPLETE_METHOD_PAY_TYPES.PSE) {
      return this.addressInfo;
    }
  }

  /**
   * @description {validContactIndformation} Function to validate the contact information of the order
   */
  validContactIndformation(
    isEditableInfo: boolean,
    contactInformation: any,
    buyerInformationComponent: BuyerInformationComponent,
    objectControlData: any,
    buyerInfoControl: any
  ) {
    buyerInfoControl = objectControlData
      .filter(
        (item: { formControl: string }) =>
          item.formControl === AUTOCOMPLETE_FORM_CONTROLS.CELLPHONE || item.formControl === AUTOCOMPLETE_FORM_CONTROLS.EMAIL
      )
      .map((item: { formControl: any; readOnly: any }) => ({
        formControl: item.formControl,
        readOnly: item.readOnly,
      }));

    if (!contactInformation) return;

    if (contactInformation.phone) {
      buyerInformationComponent.form.controls.cellPhone.setValue(
        contactInformation.phone
      );

      buyerInfoControl.find((m) => m.formControl === AUTOCOMPLETE_FORM_CONTROLS.CELLPHONE).readOnly =
        isEditableInfo;
    }

    if (contactInformation.email) {
      buyerInformationComponent.form.controls.email.setValue(
        contactInformation.email
      );

      buyerInfoControl.find((m) => m.formControl ===  AUTOCOMPLETE_FORM_CONTROLS.EMAIL).readOnly =
        isEditableInfo;
    }

    return buyerInfoControl;
  }

  /**
   *
   * @description {setReadOnly} function to activate readOnly inout form
   * @param isEditableInfo
   * @param controlName
   */
  setReadOnly(
    isEditableInfo: boolean,
    controlName: string,
    objectControlData: any
  ) {
    objectControlData.find((m) => m.formControl === controlName).readOnly =
      isEditableInfo;
  }
}
